namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1602Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        SupplId: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
    }

    export class QRywcSpec1602Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1602';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1602Form.init)  {
                QRywcSpec1602Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRywcSpec1602Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'SupplId', w0,
                    'CatCode', w0
                ]);
            }
        }
    }
}
